import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ENG from "./en.json";
import LV from "./lv.json";
import CATEGORY_LV from "./categories.json";
import CATEGORY_ENG from "./categoriesEN.json";
import COUNTRY_LV from "./countries.json";
import COUNTRY_ENG from "./countriesEN.json";
import definedLocales from "./definedLocales";

const resources = {
  LV: {
    common: LV,
    country: COUNTRY_LV,
    category: CATEGORY_LV,
  },
  EN: {
    common: ENG,
    country: COUNTRY_ENG,
    category: CATEGORY_ENG,
  },
};
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    defaultNS: "common",
    lng: definedLocales.latvian,
    fallbackLng: definedLocales.english,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
